import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { NonInteractiveContinueHandlerType, NonInteractiveRenderViewReturnType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { SingleImage } from '../../../React/features/Chat/features/SingleImage';

export const COMPONENT_IDENTIFIER = 'single-image';
const COMPONENT_ROOT_CLASS_NAME = `chat-${COMPONENT_IDENTIFIER}-container`;

export type RenderSingleImagePropsType = RenderViewPropsType<{
  imagePaths: {
    imagePath: string;
    webp?: string;
  };
  altText: string;
  viewWidth?: {
    pc: number;
    mobile: number;
  };
  viewHeight?: {
    pc: number;
    mobile: number;
  };
  imageRatio: {
    width: number;
    height: number;
  }
  waitTime?: number;
  delayTime?: number;
  withWebp?: boolean;
}>

export const renderSingleImage = async (props: RenderSingleImagePropsType): RenderViewReturnType<NonInteractiveRenderViewReturnType> => {
  const { chatRoot } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(COMPONENT_ROOT_CLASS_NAME);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: NonInteractiveContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<SingleImage {...props} continueHandler={continueHandler} />);
  });
};
